// src/components/CustomPagination/CustomPagination.js

import React from 'react';
import { Pagination } from 'react-bootstrap';

const CustomPagination = ({ totalPages, selectedPage, handlePageChange }) => {
  
  // Funzione per generare i numeri di pagina da visualizzare
  const generatePageNumbers = () => {
    const pageNumbers = [];
    const pageNeighbours = 1; // Quanti numeri mostrare prima e dopo la pagina corrente
    const totalNumbersToShow = (pageNeighbours * 2) + 3; // E.g., 1, ..., 4, 5, 6, ..., 10
    const totalBlocks = totalNumbersToShow + 2;

    if (totalPages > totalBlocks) {
      const startPage = Math.max(2, selectedPage - pageNeighbours);
      const endPage = Math.min(totalPages - 1, selectedPage + pageNeighbours);

      pageNumbers.push(1); // Sempre la prima pagina

      if (startPage > 2) {
        pageNumbers.push('...');
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      if (endPage < totalPages - 1) {
        pageNumbers.push('...');
      }

      pageNumbers.push(totalPages); // Sempre l'ultima pagina
    } else {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    }
    return pageNumbers;
  };

  const pageItems = generatePageNumbers();

  if (totalPages <= 1) {
    return null; // Non mostrare la paginazione se c'è solo una pagina
  }

  return (
    <Pagination>
      <Pagination.First onClick={() => handlePageChange(1)} disabled={selectedPage === 1} />
      <Pagination.Prev onClick={() => handlePageChange(selectedPage - 1)} disabled={selectedPage === 1} />

      {pageItems.map((page, index) => {
        if (page === '...') {
          return <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />;
        }
        return (
          <Pagination.Item
            key={page}
            active={page === selectedPage}
            onClick={() => handlePageChange(page)}
          >
            {page}
          </Pagination.Item>
        );
      })}

      <Pagination.Next onClick={() => handlePageChange(selectedPage + 1)} disabled={selectedPage === totalPages} />
      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={selectedPage === totalPages} />
    </Pagination>
  );
};

export default CustomPagination;